RivalIQ.apps.Registration.module('controller', function (controller, App, Backbone, Marionette, $, _) {

    'use strict';

    const NUM_COMPETITORS = 3;

    const Controller = Marionette.Controller.extend({

        start: function (options) {
            const me = this;

            me.options = _.extend({}, options);

            const attrs = _.extend({}, options.user, {
                account: {}
            });
            attrs.password = attrs.passwordConfirmation = '';

            const competitors = _.times(NUM_COMPETITORS, function (idx) {
                return {};
            });

            me.model = new Backbone.Model({
                isAgency: options.isAgency,
                user: new App.models.User(attrs, {
                    parse: true,
                    validateNameAndPassword: true
                }),
                focusCompanyUrl: options.focusCompanyUrl,
                focusCompany: new App.models.LandscapeCompany(),
                competitors: new App.collections.LandscapeCompanies(competitors)
            });

            me.listenTo(App, 'name-and-password-complete', me.onNamePasswordComplete);
            me.listenTo(App, 'registration-complete', me.onRegistrationComplete);

            me.showDetails();
            me.showHeaderAndFooter();

            if (options.trackSignUp) {
                me.pushTrackingEvent('V3SignedUp');
            }

            me.pushTrackingEvent('V3RegistrationStarted');
        },

        showHeaderAndFooter: function () {
            // This is necessary for the sticky footer. See https://getbootstrap.com/docs/3.3/examples/sticky-footer-navbar/
            $('html').css({
                'position': 'relative',
                'min-height': '100%'
            });

            $('.header-image').show();
            $('.page-footer').show();
        },

        onNamePasswordComplete: function () {
            const me = this;
            App.mainRegion.show(new App.views.RegistrationDetails({
                model: me.model
            }));
        },

        // show a view asking the user to confirm their name and enter a password.
        showDetails: function () {
            const me = this;

            App.mainRegion.show(new App.views.UserDetails({
                model: me.model.get('user')
            }));

            me.pushTrackingEvent('V3RegistrationViewedDetails');
        },

        onRegistrationComplete: function () {
            const data = {
                type: 'email',
                trigger_type: 'active_trial_start'
            };

            $.post('/api/triggers', data);

            window.location = '/postregistration';
        },

        pushTrackingEvent: function (event, eventOptions) {
            RivalIQ.execute('tracking:push:auth', event, eventOptions);
        }
    });

    controller.addInitializer(function (options) {
        const controller = new Controller();
        controller.start(options);
    });
});
